/*global jQuery*/

jQuery(document).ready(function ($) {
  'use strict'


  // *************************
  // *
  // * Accordion
  // *
  // *************************

  jQuery(document).ready(function($) {
    $('.accordion-toggle').click(function(){

      //Expand or collapse this panel
      $(this).next().slideToggle('fast');

      //Hide the other panels
      $(".accordion-container").not($(this).next()).slideUp('fast');

      //Switch toggle
      $('.accordion-toggle.toggle-open').not(this).removeClass('toggle-open');
      $(this).toggleClass('toggle-open');
    });
  });





})
